
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 108 72"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h108v72H0z","fill":"#003787"}}),_c('path',{attrs:{"d":"M0 0h108L60 48v24H48V48z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"54","cy":"30","r":"8","fill":"#f9d90f"}}),_c('path',{attrs:{"d":"M44 30h20L54 48z","fill":"#fff"}}),_c('path',{attrs:{"d":"M54 48L38 33h32z","fill":"#cf142b"}})])
          )
        }
      }
    